const navMenuToggle = ( $ ) => {
	$('#nav-toggle').on('click', function() {
		$('body').toggleClass('js--nav-open');

		if ( $('body').hasClass('js--nav-open') ) {
			// add the top nav to main nav when menu is open
			$('#menu-main').append($('#menu-upper').contents());
		} else {
			// put back the top nav elements back when menu is closed
			$('#menu-upper').append($('#menu-main').find('li:nth-last-of-type(-n+2)'));
		}
	})
}

export default navMenuToggle;
